<template>
    <div id="main">
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import Api from './../api';

    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');

export default {
    data() {
        return {
            show: false,
            listPixel: []
        }
    },

    created(){
        this.getFacebookPixelActiveAll();
    },

    mounted(){
        // fbq('init', '1181118342256544');
        // fbq('init', '1385513191637591');
        // fbq('track', 'PageView');
    },

    methods:{
        getFacebookPixelActiveAll(){
            this.show = true;
            Api.getFacebookPixelActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.listPixel = data.result;
                    this.listPixel.forEach(el => {
                        fbq('init', el.pixel);
                    });
                    fbq('track', 'PageView');
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },
    }
}
</script>
<style scoped>
</style>